// src/components/Footer.jsx
import {
  Box,
  Container,
  Stack,
  Text,
  Link,
  useColorModeValue,
  Icon,
  HStack,
  VStack,
} from '@chakra-ui/react';
import { FaXTwitter } from 'react-icons/fa6';
import {
  FaInstagram,
  FaFacebook,
  FaLinkedin,
  FaTiktok,
  FaYoutube,
} from 'react-icons/fa';

const Footer = () => {
  return (
    <Box
      bg={useColorModeValue('white', 'brand.bgDarker')}
      color={useColorModeValue('gray.700', 'gray.200')}
      borderTop="1px"
      borderColor={useColorModeValue('gray.200', 'brand.successDarker')}
      mt="auto"
    >
      <Container as={Stack} maxW="container.xl" py={8} spacing={4}>
        <VStack spacing={6}>
          {/* Main links */}
          <HStack spacing={6} wrap="wrap" justify="center">
            <Link href="/privacy-policy">Privacy Policy</Link>
            <Link href="/terms-of-service">Terms of Service</Link>
            <Link href="mailto:info@conversify.org">Contact (info@conversify.org)</Link>
            <Link href="mailto:support@conversify.org">Support (support@conversify.org)</Link>
          </HStack>

          <HStack spacing={6} wrap="wrap" justify="center">
            <Link
              href="https://x.com/Conversify_"
              isExternal
              display="flex"
              alignItems="center"
              color={useColorModeValue('brand.success', 'brand.successLight')}
              _hover={{
                color: useColorModeValue(
                  'brand.successDark',
                  'brand.successLight'
                ),
              }}
            >
              <Icon as={FaXTwitter} boxSize={6} mr={2} />{' '}
              {/* Made it slightly bigger */}
            </Link>

             <Link
              href="https://www.instagram.com/conversifyofficial"
              isExternal
              display="flex"
              alignItems="center"
              color={useColorModeValue('brand.success', 'brand.successLight')}
              _hover={{
                color: useColorModeValue(
                  'brand.successDark',
                  'brand.successLight'
                ),
              }}
            >
              <Icon as={FaInstagram} boxSize={6} mr={2} />{' '}
            </Link>

            <Link
              href="https://www.tiktok.com/@conversifyofficial"
              isExternal
              display="flex"
              alignItems="center"
              color={useColorModeValue('brand.success', 'brand.successLight')}
              _hover={{
                color: useColorModeValue(
                  'brand.successDark',
                  'brand.successLight'
                ),
              }}
            >
              <Icon as={FaTiktok} boxSize={6} mr={2} />{' '}
            </Link>

            {/*
            <Link
              href="/sorrytokeepyouwaiting.gif"
              isExternal
              display="flex"
              alignItems="center"
              color={useColorModeValue('brand.success', 'brand.successLight')}
              _hover={{
                color: useColorModeValue(
                  'brand.successDark',
                  'brand.successLight'
                ),
              }}
            >
              <Icon as={FaLinkedin} boxSize={6} mr={2} />{' '}
            </Link>

            <Link
              href="/sorrytokeepyouwaiting.gif"
              isExternal
              display="flex"
              alignItems="center"
              color={useColorModeValue('brand.success', 'brand.successLight')}
              _hover={{
                color: useColorModeValue(
                  'brand.successDark',
                  'brand.successLight'
                ),
              }}
            >
              <Icon as={FaFacebook} boxSize={6} mr={2} />{' '}
            </Link>

            <Link
              href="/sorrytokeepyouwaiting.gif"
              isExternal
              display="flex"
              alignItems="center"
              color={useColorModeValue('brand.success', 'brand.successLight')}
              _hover={{
                color: useColorModeValue(
                  'brand.successDark',
                  'brand.successLight'
                ),
              }}
            >
              <Icon as={FaYoutube} boxSize={6} mr={2} />{' '}
            </Link> */}
          </HStack>

          {/* Copyright and DBA */}
          <Text fontSize="sm" textAlign="center" color="gray.500">
            © {new Date().getFullYear()} Conversify. All rights reserved.
            <br />
            <br />
            Conversify is a service of FLINTMANAGEMENT, LLC.
          </Text>
        </VStack>
      </Container>
    </Box>
  );
};

export default Footer;
